<template>
    <v-layout v-if="isDevEnv" justify-center align-baseline>
        <v-card class="login__form mt-4 px-4">
            <div>
                <v-card-title class="pl-0 pr-4">
                    <span class="login__title">Log in</span>
                </v-card-title>
                <v-form novalidate @submit.stop.prevent="handlelogIn()">
                    <v-text-field label="Email" v-model="email" class="custom" :rules="rules" required>
                    </v-text-field>

                    <v-text-field label="Password" v-model="password" class="custom password-field" :rules="rules" required
                        :append-icon="showPassword ? 'visibility_off' : 'visibility'" :type="showPassword ? 'text' : 'password'"
                        :append-icon-cb="changePasswordIcon"
                    >
                    </v-text-field>

                    <v-btn flat type="submit" :loading="waitlogin" :disabled="waitlogin" block>Log in</v-btn>
                </v-form>
            </div>
            <v-card-text v-if="failed || userAlert">
                <span class="red--text" v-if="failed">{{errorMessage}}</span>
                <span class="red--text" v-if="userAlert">Avaliable only for administrator.</span>
            </v-card-text>
        </v-card>
    </v-layout>
    <div v-else class="login-content"> 
        <div class="login-content--left-col">
            <img :src="loginLogo" class="login-logo">
            <v-card class="login__form mt-4 px-4">
                <div>
                    <v-btn flat :loading="waitlogin" :disabled="waitlogin" @click="onGoogleLogin" block class="google-button">
                        <img :src="srcPhoto">
                        <span>Sign in with Google</span>
                    </v-btn>
                </div>
            </v-card>
        </div>
        <div class="login-content--right-col">
        </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import Vue from 'vue';
import AuthService from '@/services/AuthService';
import LoginLogo from '@/../static/login-logo.png';

export default {
    data() {
        return {
            email: '',
            password: '',
            loginPasswordVisible: false,
            rules: [value => !!value || 'This field is required'],
            failed: false,
            errorMessage: '',
            waitlogin: false,
            userAlert: false,
            showPassword: false,
            loginLogo: LoginLogo
        };
    },
    computed: {
        srcPhoto() {
            return require('@/assets/google-login-icon.png');
        },
        isDevEnv() {
            return process.env.IS_DEMO === true;
        }
    },
    methods: {
        ...mapActions(['logIn', 'googleLogIn']),
        handlelogIn() {
            this.failed = false;
            this.waitlogin = true;
            this.logIn({
                Email: this.email,
                Password: this.password
            }).then(
                res => {
                    this.userAlert = !AuthService.isAdmin();
                    this.waitlogin = false;
                },
                error => {
                    this.failed = true;
                    this.errorMessage = 'The email or password is incorrect. Please try again.';
                    this.waitlogin = false;
                    this.userAlert = false;
                }
            );
        },
        onGoogleLogin() {
            this.failed = false;
            this.waitlogin = true;
            Vue.googleAuth().signIn(code => {
                this.googleLogIn(code).then(
                    res => {
                        this.userAlert = !AuthService.isAdmin();
                        this.waitlogin = false;
                    },
                    error => {
                        this.failed = true;
                        this.errorMessage = 'Google account is incorrect. Please try again.';
                        this.waitlogin = false;
                        this.userAlert = false;
                    }
                );
            },
            error => {
                this.waitlogin = false;
            });
        },
        changePasswordIcon() {
            this.showPassword = !this.showPassword;
        }
    }
};
</script>

<style scoped>
.login__form >>> label {
  position: static;
  transform: none !important;
  -webkit-transform: none !important;
  font-size: 12px;
  margin-bottom: -7px;
  margin-top: -3px;
}
.custom {
  padding-top: 0px;
}

.google-button >>> div.btn__content {
    padding: 0px;
}
.google-button >>> img {
    height: 24px;
    margin-right: 10px;
}

div.card__text {
    text-align: center;
}

.login-content {
    display: flex;
    height: 100vh;
}

.login-content--left-col {
    position: relative;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    -ms-flex-align: center;
    align-items: center;
    width: 50%;
    padding-top: 100px;
}

.login-content--right-col {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-pack: center;
    justify-content: center;
    width: 50%;
    background: url(/static/login-img.png) no-repeat;
    background-color: #2767FF;
    background-position: center center;
}

.login-logo {
    width: 224px;
    height: 56px;
    background-position: center center;
    margin-bottom: 109px;
}
@media (max-width: 550px) {
    .login__form {
        width: 90%;
    }

    .login-logo {
        width: 90%;
    }

    .google-button .btn__content span {
        font-size: 11px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/pages/Authentication.vue